module.exports = __webpack_public_path__ + "img/samu.e01cd79c.png";